import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface SetTransferenciaMetodosRequestDetail{
    id?:string,
    nombre:string,
    hidden:boolean
}

export interface SetTransferenciaMetodosRequest{
    details:SetTransferenciaMetodosRequestDetail[]
}

export async function setTrasnferenciaMetodos(request:SetTransferenciaMetodosRequest):Promise<TransferenciaMetodo[]>{
    await sleep(1000);
    const response = await api.post("monetizacion/transferencia_metodos", request);
    return response.data;
}

export function useSetTrasnferenciaMetodosMutation(mutationConfig: MutationConfig<TransferenciaMetodo[], SetTransferenciaMetodosRequest> = {}){
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: setTrasnferenciaMetodos,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["monetizacion", "transferencia_metodos"] });
        },
    })
}

export interface SetTrasnferenciaMetodosMutationProps {
    mutationConfig?: MutationConfig<TransferenciaMetodo[], SetTransferenciaMetodosRequest>,
    children?: (mutationResult: MutationResult<TransferenciaMetodo[], SetTransferenciaMetodosRequest>) => ReactNode
}

export function SetTrasnferenciaMetodosMutation({
    mutationConfig,
    children
}: SetTrasnferenciaMetodosMutationProps) {
    const mutationResult = useSetTrasnferenciaMetodosMutation(mutationConfig);
    return children && children(mutationResult);
}